export default function stringifySafe(input: unknown) {
  return typeof input === 'string' ? input : JSON.stringify(input);
}
